module.exports = __webpack_public_path__ + "static/media/add.7ca4d58d.svg";